import Image from 'components/image'

import getConfig from 'next/config'
const {
  publicRuntimeConfig: { categoriesID },
} = getConfig()

import ImageType from 'store/types/ts/image'
import { DefaultImageEnum } from 'util/default-image'
import style from './article-image.module.scss'

interface Props {
  image?: ImageType
  heroImage?: ImageType
  category: string
  slug: string
}

const ArticleImage = ({ image, heroImage, category, slug }: Props) => {
  const renderEmpiresLogo = () => {
    const logoUrl = `/images/logos/${slug}-black-logo.png`
    return (
      <div className={style.bg}>
        <div className={style.innerbg}>
          <Image images={[image]} objectFit="cover" alt="" />
          <div>
            <Image
              image={logoUrl}
              resizeProps={{
                w: 250,
                h: 250,
              }}
              objectFit="scale-down"
              alt={`${slug} logo`}
            />
          </div>
        </div>
      </div>
    )
  }

  const renderLogo = () => {
    if (image) {
      return (
        <div className={style.bg}>
          <div className={style.innerbg}>
            <Image
              images={[heroImage]}
              defaultImageName={DefaultImageEnum.ArticleNeutralBackground}
              objectFit="cover"
              alt=""
            />
            <div>
              <Image
                images={[image]}
                resizeProps={{
                  w: 350,
                  h: 350,
                }}
                alt={`${slug} logo`}
              />
            </div>
          </div>
        </div>
      )
    }
  }

  const renderDefault = () => {
    if (image) {
      return (
        <div className={style.bg}>
          <div className={style.inner}>
            <Image images={[image]} objectFit="cover" alt={`${slug} logo`} />
          </div>
        </div>
      )
    }

    // No image set
    return <></>
  }

  const renderImage = () => {
    switch (category) {
      case categoriesID.empires:
        return renderEmpiresLogo()
      case categoriesID.factions:
        return renderLogo()
      case categoriesID.corporations:
        return renderLogo()
      default:
        return renderDefault()
    }
  }

  return <>{renderImage()}</>
}

export default ArticleImage
